import React from "react";
import { Link } from "react-router-dom";

const TermsPolicy = ({ className = "" }) => {
  return (
    <div className={`mt-3 text-center ${className}`}>
      <p className="text-[11px] text-gray-400 font-medium leading-relaxed">
        By continuing, you agree to Practido's{" "}
        <Link to="/terms" target="_blank" className="text-gray-600 hover:text-[#009DFF] underline">
          Terms of Service
        </Link>{" "}
        &{" "}
        <Link to="/privacy" target="_blank" className="text-gray-600 hover:text-[#009DFF] underline">
          Privacy Policy
        </Link>
        .
      </p>
    </div>
  );
};

export default TermsPolicy;
